export default "__VITE_ASSET__B2aOJh_K__"